<template>
	<div v-if="project">
		<NavBarProject :project="project" />
		<div class="header-project" :style="{ 'background': 'url('+project.header_url+')', 'backgroundSize': 'cover', 'backgroundPosition': 'center bottom' }">
			<b-container>
				<b-row class="project-header">
					<b-col lg="4" class="text-right">
						<b-img :src="project.logo_url" class="img-fluid w-100" alt="image" />
					</b-col>
					<b-col lg="8" class="text-left text-white">
						<h2>{{project.place}}</h2>
						<h1><b>{{project.title}}</b></h1>
						<h3 class="border-bottom-red mt-5">
							{{project.detail}}
						</h3>
						<h3>{{project.price_title}}</h3>
						<h1><b>{{project.price}}</b></h1>
					</b-col>
				</b-row>
			</b-container>
		</div>
		<b-container fluid class="bv-example-row px-0" id="project-images">
			<b-row class="align-items-center" no-gutters v-for="(detail, key) in project.details" v-bind:key="'detail-'+key">
				<b-col md="8" sm="7" data-aos="fade-down" :order-sm="(detail.left_right ? '1' : '2')">
					<b-img class="d-block img-fluid w-100" :src="detail.image_url" alt="image" />
				</b-col>
				<b-col md="4" sm="5" class="text-left" data-aos="fade-up" :order-sm="(detail.left_right ? '2' : '1')">
					<h2 class="detail-title">{{detail.title}}</h2>
				</b-col>
			</b-row>
			<b-row v-if="project.equipments" no-gutters class="bg-dark text-white equipments-container" :style="{ backgroundImage: 'url('+project.image_full_width_url+')' }" data-aos="fade-up">
				<div class="inner-bg"></div>
				<b-col class="py-5 my-5 bg-bravoizq details" offset-md="3" md="6" offset="1" cols="10">
					<b-table-simple condensed borderless class="align-top text-white">
						<b-tr v-for="(equipment, key) in project.equipments" v-bind:key="'equipments-'+key" >
							<b-td width="1px" class="text-right">
								<font-awesome-layers class="fa-2x">
									<font-awesome-icon :icon="['fal', 'circle']" transform="grow-4" />
									<font-awesome-icon :icon="['fal', equipment.icon]" :transform="'shrink-8 '+equipment.transform" />
								</font-awesome-layers>
							</b-td>
							<b-td class="text-left lead">
								{{equipment.text}}
							</b-td>
						</b-tr>
					</b-table-simple>
				</b-col>
			</b-row>
			<div class="d-lg-none text-left" v-if="project.terrain_src">
				<h4 class="text-uppercase text-left detail-title my-3">Entorno 360º</h4>
				<b-embed type="video" controls v-if="project.terrain_is_video">
					<source :src="project.terrain_src" type="video/mp4">
				</b-embed>
				<b-embed v-else :src="project.terrain_src"></b-embed>
			</div>
			<h1 v-if="project.apartments.length > 0" class="my-5 py-5 text-grey">DEPARTAMENTO</h1>
			<Carousel v-if="project.sliders"/>
			<Carousel2 v-if="project.sliders2"/>			
			<div v-if="project.sliders==null">
				<img class="d-block img-fluid w-100" v-for="(apartment, key) in project.apartments" v-bind:key="'apartment-'+key" :src="apartment.image_url" alt="image" data-aos="fade-up">
			</div>
			<div v-else-if="project.sliders2==null">
				<img class="d-block img-fluid w-100" v-for="(apartment, key) in project.apartments" v-bind:key="'apartment-'+key" :src="apartment.image_url" alt="image" data-aos="fade-up">
			</div>
			<div class="d-lg-none text-left" v-if="project.travel_src">
				<h4 class="text-uppercase text-left detail-title my-3">PRESENTACIÓN PROYECTO</h4>
				<b-embed type="video" controls v-if="project.travel_is_video">
					<source :src="project.travel_src" type="video/mp4">
				</b-embed>
				<b-embed v-else :src="project.travel_src"></b-embed>
			</div>
			<div class="d-lg-none text-left" v-if="project.pilot_src">
				<h4 class="text-uppercase text-left detail-title my-3">Piloto Virtual</h4>
				<b-embed type="video" controls v-if="project.pilot_is_video">
					<source :src="project.pilot_src" type="video/mp4">
				</b-embed>
				<b-embed v-else :src="project.pilot.src"></b-embed>
			</div>
			<div class="d-lg-none text-left" v-if="project.advance_src">
				<h4 class="text-uppercase text-left detail-title my-3">Avance de obra</h4>
				<b-embed type="video" controls v-if="project.advance_is_video">
					<source :src="project.advance_src" type="video/mp4">
				</b-embed>
				<b-embed v-else :src="project.advance_src"></b-embed>
			</div>
			<b-row no-gutters class="py-5" data-aos="fade-down">
				<b-col cols="12" lg="6" class="h1 py-4" >
					<b>Hablemos!</b>
				</b-col>
				<b-col cols="12" lg="6">
					<ExecutiveAvatar :executive="project.executive" v-if="project.executive" />
					<ExecutiveAvatar :executive="project.second_executive" v-if="project.second_executive" />
				</b-col>
			</b-row>
			<l-map id="project-map" :zoom="16" :center="location" :options="{scrollWheelZoom: false}" style="width: 100%; height: 300px">
				<l-tile-layer id="mapbox/light-v9" url="https://cartodb-basemaps-{s}.global.ssl.fastly.net/light_all/{z}/{x}/{y}.png" attribution="" />
				<l-marker :lat-lng="location"></l-marker>
			</l-map>
			<div v-if="project.bases_concurso_estado">
				<b><a class="title-bases" :href="project.bases_concurso" target="_blank">Bases legales Promoción</a></b>
			</div>
		</b-container>
		<table class="quote-button" @click="goTo('quote', {project_id: project.url})" v-if="project.btn_cotizar">
			<tr>
				<td>
					<a href="javascript:;" class="nav-link text-white">COTIZA</a>
				</td>
				<td></td>
			</tr>
		</table>
		<table class="whatsapp-button" v-if="project.executive.clean_phone">
			<tr>
				<td>
					<a :href="'https://api.whatsapp.com/send?phone='+project.executive.clean_phone" class="nav-link text-white">
						<font-awesome-icon :icon="['fab', 'whatsapp']" size="2x" class="text-white" />
					</a>
				</td>
				<td></td>
			</tr>
		</table>
		<table class="santander-button" v-if="project.executive.clean_phone">
			<tr>
				<td>
					<a :href="'https://banco.santander.cl/personas/credito-hipotecario/pre-evaluador '" class="nav-link text-white">
						<img src="@/assets/images/logo_santander2.svg">
					</a>
				</td>
				<td></td>
			</tr>
		</table>
		<table class="bci-button" v-if="project.btn_bci" @click="verModal()">
			<tr>
				<td>
					<a  class="nav-link text-white">
						<img src="@/assets/images/logo-bci.svg">
					</a>
				</td>
				<td></td>
			</tr>
		</table>
	</div>
</template>
<script>
	//import CarouselSlide2 from '../../../components/CarouselSlide2.vue';
	import NavBarProject from '../../../components/NavBarProject.vue';
	import Carousel from '../../../components/Carousel.vue';
	import Carousel2 from '../../../components/Carousel2.vue';
	import { latLng } from "leaflet";
	import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
	import ExecutiveAvatar from '../../../components/ExecutiveAvatar.vue';
    //import { faSearchMinus } from '@fortawesome/pro-light-svg-icons';
	export default {
		name: 'project',
		props: {
			project_id: {default: null},
			scrollTo: {default: null}
		},
		data(){
			return{
				project: null,
				location: null,
				token_dhunter:null,
			}
		},
		components: {
			NavBarProject,
			ExecutiveAvatar,
			LMap,
			LTileLayer,
			LMarker,
			Carousel,
			Carousel2
		},
		beforeMount() {
			this.project = this.$store.getters.getProjectByUrl(this.project_id);
			if(this.project){
				let location = this.project.location.split(',');
				this.location = location.length > 1 ? latLng(location[0],location[1]) : null;
			}else{
				this.$store.commit('setProjects')
			}

		},
		mounted() {			
			/*
			if(this.project.sliders.length>0)
			this.$store.state.sliders = this.project.sliders;
			*/
			//this.$store.sliders = sliders;
			
			/*
			switch(this.project_id)
			{
				case 'iq':
					console.log('entra');
					this.gtag('event', 'conversion', {'send_to': 'AW-650047078/M_LfCOyc8IsDEObc-7UC'});
				break;	
				case 'vm':
					this.gtag('event', 'conversion', {'send_to': 'AW-650047078/Sg3oCO3Zx4sDEObc-7UC'});
				break;
				case 'cu':
					this.gtag('event', 'conversion', {'send_to': 'AW-650047078/_NBmCI_Q8NkBEObc-7UC'});
				break;
				case 'connection':
					this.gtag('event', 'conversion', {'send_to': 'AW-650047078/TIv9CLu-js4BEObc-7UC'});
				break;
			}
			*/
			

			if(this.scrollTo){
				this.scrollToElem(this.scrollTo);
			}

			this.$root.captureUtm();
			this.$root.sessionStorageSet('utm_dhunter','inmobiliariabi');
			
			this.$store.state.popup = false;
			
			/*
			if(this.project.lightbox&&this.$store.state.popup==false){						
			this.$bvModal.show('modal-lightbox');
			this.$store.state.popup = true;
			}
			*/

			setTimeout(()=>{
			this.$bvModal.show('modal-lightbox');
			},1000)
			

			if(document.getElementById('tidio-chat')==null)
			{
			let recaptchaScript = document.createElement('script');
			recaptchaScript.setAttribute('src', '//code.tidio.co/8ehjlz546slsczjku9jwyo2mnbbrzzmk.js');
			recaptchaScript.setAttribute('id','chat-script');
			document.head.appendChild(recaptchaScript);
			}

			if(document.getElementById('tidio-chat'))
			document.getElementById('tidio-chat').style.display='block';
		},
		methods: {
			goTo(url, params){
				this.$router.push({ name: url, params: params }).catch(err => { console.log('ERROR:',err) });
			},
			scrollToElem(elemName) {
				window.scroll({
					top: document.querySelector(elemName).offsetTop,
					behavior: 'smooth'
				});
			},
			verModal(){
				this.vendedor = this.project.url; //atributo de witget bci					
				this.token_dhunter="123456789";
				this.$bvModal.show('modal-bci');
				document.querySelector('bci-widget').addEventListener('preaprobacion', event => {
				this.get_info_rut(event.detail.email,event.detail.rut,event.detail.estado,event.detail.telefono,event.detail.montoSolicitado,this.token_dhunter);
			});
			},
			get_info_rut(email, rut, estado, telefono, monto, token_dhunter) {
				console.log(email);
				console.log(rut);
				console.log(estado);
				console.log(telefono);
				console.log(monto);
				console.log(token_dhunter);
			fetch('https://siichile.herokuapp.com/consulta?rut='+rut).then(response => {
					console.log(response);
			}, error =>{
			console.log(error)
		})
	/*
	$.getJSON('https://siichile.herokuapp.com/consulta', {
        rut: rut
    }, function(result) {
        
        var datos = {
            idfuncion: 2,
            rut: rut,
            nombre: result.razon_social,
            apellido: '',
            telefono: telefono,
            email: email,
            region: 0,
            provincia: 0,
            comuna: 0,
            msj_comment: estado + ' // Monto: UF ' + monto,
            id_planta: 0,
            origen: 'BCI',
            pie: 0,
            plazo: 0,
            tasa: '',
            interes: 0,
            key_cap: token_dhunter
        }; //token
        $.ajax({
            type: 'POST',
            url: 'https://datahunter.cl/sistema/lib/modulos/cotizacion/modulo.php',
            data: datos,
            dataType: 'json',
            success: function(a) {

            }
        });
		
    });*/
}	
		},
		watch: {
			'$store.state.projects': {
				handler: function()  {
					this.project = this.$store.getters.getProjectByUrl(this.project_id);
					if(this.project){
						let location = this.project.location.split(',');
						this.location = location.length > 1 ? latLng(location[0],location[1]) : null;
					}
				}
			}
		}
	}
</script>
<style>
	.title-bases{
		display: block;
		margin-top: 20px;
		text-decoration: none;
		text-align: center;
		color: #2c3e50;
	}

	#app {
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
	}
	.detail-title {
		font-size: 2rem;
		line-height: 2rem;
		margin-left: 1.5rem;
		padding: 0px;
		padding-left: 1.5rem;
		display: inline-block;
		color: #6f6f6f;
		border-left: 3px solid #b12525;
	}
	.text-red{
		color: #b12525 !important;
		text-transform: uppercase;
		font-weight: bold;
	}
	.border-bottom-red{
		padding-bottom: 10px;
		border-bottom: 3px solid #b12525;
	}
	.project-header{
		padding-top: 30vh;
	}
	.project-header h1{
		font-size: 4.5rem;
		line-height: 4.5rem;
		text-transform: uppercase;
	}
	.project-header h2{
		font-size: 2.5rem;
		line-height: 2.5rem;
		text-transform: uppercase;
	}
	.project-header h3{
		font-size: 1.9rem;
		line-height: 1.9rem;
		text-transform: uppercase;
	}
	.details{
		padding-left: 3rem !important;
		padding-right: 3rem !important;
	}
	@media (max-width: 800px){
		.detail-title {
			font-size: 1.5rem;
			line-height: 1.5rem;
			margin-top: 20px;
			margin-bottom: 20px;
		}
		.project-header h1{
			font-size: 2rem;
			line-height: 2rem;
		}
		.project-header h2{
			font-size: 1.5rem;
			line-height: 1.5rem;
		}
		.project-header h3{
			font-size: 1rem;
			line-height: 1rem;
		}
		.project-header{
			padding-top: 100px;
		}
		.header-project{
			height: 100vh;
		}
		.lead{
			font-size: 1rem !important;
		}
		.details{
			padding-left: 15px !important;
			padding-right: 15px !important;
		}
	}
	.equipments-container{
		position: relative;
		background-position: middle;
		background-size: cover;
		background-repeat: none;
	}
	.equipments-container .inner-bg{
		background: rgba(53, 53, 53, 0.329);
		position: absolute;
		top: 0;
		width: 100%;
		height: 100%;
		backdrop-filter: blur(3px)
	}
</style>
